const path = (root: string, sublink: string) => {
    return `${root}${sublink}`;
};

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

export const PATH_AUTH = {
    root: ROOTS_AUTH,
    login: path(ROOTS_AUTH, '/login'),
    register: path(ROOTS_AUTH, '/register'),
    resetPassword: path(ROOTS_AUTH, '/reset-password'),
    verify: path(ROOTS_AUTH, '/verify'),
    userManagement: path(ROOTS_AUTH, '/user-management'),
};

export const PATH_PAGE = {
    page404: '/404',
    page500: '/500',
};

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    general: {
        modules: path(ROOTS_DASHBOARD, '/modules'),
    },
    account: {
        root: path(ROOTS_DASHBOARD, '/account'),
    },
    points: {
        root: path(ROOTS_DASHBOARD, '/points'),
    },
    groups: {
        root: path(ROOTS_DASHBOARD, '/groups'),
        group: (id: string) => path(ROOTS_DASHBOARD, `/groups/${id}`),
        groupContent: path(ROOTS_DASHBOARD, '/groups/:group/content'),
        new: path(ROOTS_DASHBOARD, '/groups/new'),
        edit: (id: string) => path(ROOTS_DASHBOARD, `/groups/${id}/edit`),
    },
    users: {
        root: path(ROOTS_DASHBOARD, '/users'),
        new: path(ROOTS_DASHBOARD, '/users/new'),
        user: (id: string) => path(ROOTS_DASHBOARD, `/users/${id}`),
        edit: (id: string) => path(ROOTS_DASHBOARD, `/users/${id}/edit`),
        // newChild: (id: string) => path(ROOTS_DASHBOARD, `/users/${id}/children/new`),
        editChild: (parentId: string, childId: string) =>
            path(ROOTS_DASHBOARD, `/users/${parentId}/children/${childId}/edit`),
    },
    children: {
        root: path(ROOTS_DASHBOARD, '/children'),
        new: path(ROOTS_DASHBOARD, '/children/new'),
        child: (id: string) => path(ROOTS_DASHBOARD, `/children/${id}`),
        edit: (id: string) => path(ROOTS_DASHBOARD, `/children/${id}/edit`),
    },
    schedule: {
        root: path(ROOTS_DASHBOARD, '/schedule'),
    },
    studies: {
        root: path(ROOTS_DASHBOARD, '/studies'),
        attendance: path(ROOTS_DASHBOARD, '/studies/attendance'),
        schedule: path(ROOTS_DASHBOARD, '/studies/schedule'),
        points: path(ROOTS_DASHBOARD, '/studies/points'),
        diploma: path(ROOTS_DASHBOARD, '/studies/diploma'),
        feedback: path(ROOTS_DASHBOARD, '/studies/feedback'),
    },
    attendance: {
        root: path(ROOTS_DASHBOARD, '/attendance'),
        report: (id: string) => path(ROOTS_DASHBOARD, `/attendance/${id}`),
        dailySheet: (id: string, date: string) => path(ROOTS_DASHBOARD, `/attendance/${id}/daily-sheet/${date}`),
    },
    analytics: {
        root: path(ROOTS_DASHBOARD, '/analytics'),
    },
    teacherPrizes: {
        root: path(ROOTS_DASHBOARD, '/teacher-prizes'),
    },
};
